module.exports = __webpack_public_path__ + "static/img/celoscope-29.3873bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-29.jpg
// module id = lpwF
// module chunks = 51